// src/UpcomingEvents.js
import React from 'react';
import { COLORS } from './theme';
import { getMemberRole } from './utils'; 
import './App.css'; // スタイル読み込み

const UpcomingEvents = ({ events, onSelectDate }) => {
  const today = new Date().toISOString().split('T')[0];
  
  const upcoming = events
    .filter(e => e.isoDate >= today && e.status !== 'cancelled')
    .sort((a, b) => a.isoDate.localeCompare(b.isoDate))
    .slice(0, 3); // 直近3件

  if (upcoming.length === 0) return null;

  return (
    <div style={{ marginTop: '20px', padding: '0 5px' }}>
      <h3 style={{ fontSize: '16px', color: '#444', marginBottom: '10px', display:'flex', alignItems:'center' }}>
        🚀 直近の活動予定
      </h3>
      <div style={{ display: 'grid', gap: '12px' }}>
        {upcoming.map(event => {
          // ■ FP/GKごとの人数集計
          const members = event.members || [];
          const waitlist = event.waitlist || [];
          
          // ★修正箇所: 0を数値として正しく認識させる (undefinedの時だけデフォルト値を使う)
          const limitFP = event.limitFP !== undefined ? event.limitFP : 20;
          const limitGK = event.limitGK !== undefined ? event.limitGK : 2;

          // 参加済み人数
          const currentFP = members.filter(m => getMemberRole(m) === 'FP').length;
          const currentGK = members.filter(m => getMemberRole(m) === 'GK').length;

          // キャンセル待ち人数
          const waitFP = waitlist.filter(m => getMemberRole(m) === 'FP').length;
          const waitGK = waitlist.filter(m => getMemberRole(m) === 'GK').length;

          // 残り枠
          const remainFP = limitFP - currentFP;
          const remainGK = limitGK - currentGK;

          // ■ 表示テキストと色の生成ロジック
          const getStatusText = (role, remain, wait) => {
             if (wait > 0) return `${role}待ち(${wait})`;
             if (remain <= 0) return `${role}満員`;
             return `${role}残${remain}`;
          };

          const fpText = getStatusText('FP', remainFP, waitFP);
          const gkText = getStatusText('GK', remainGK, waitGK);
          const fullText = `${fpText} / ${gkText}`;

          // バッジの色決定 (待ちがいれば赤、満員ならグレー、空きなら緑)
          let statusBg = '#e8f5e9'; // デフォルト緑（募集中）
          let statusColor = '#2e7d32';
          let borderColor = '#2e7d32';

          const hasWait = waitFP > 0 || waitGK > 0;
          const isFull = (remainFP <= 0 && remainGK <= 0) && !hasWait;

          if (hasWait) {
              statusBg = '#fff3e0'; // オレンジ（待ちあり）
              statusColor = '#e65100';
              borderColor = '#e65100';
          } else if (isFull) {
              statusBg = '#f5f5f5'; // グレー（満員）
              statusColor = '#666';
              borderColor = '#999';
          }

          // 時間整形
          const startTime = event.time ? event.time.split('-')[0] : '';

          return (
            <div 
              key={event.id} 
              className="card"
              onClick={() => onSelectDate(new Date(event.isoDate))}
              style={{
                padding: '15px',
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                // 左線の色: 待ちがいれば赤、それ以外は緑
                borderLeft: `5px solid ${hasWait ? COLORS.danger : COLORS.primary}`,
                marginBottom: 0
              }}
            >
              {/* 日付・時間 */}
              <div style={{ textAlign: 'center', marginRight: '15px', minWidth: '45px' }}>
                <div style={{ fontSize: '11px', color: '#999', textTransform:'uppercase' }}>
                    {event.isoDate.split('-')[1]}/{event.isoDate.split('-')[2]}
                </div>
                <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#333' }}>
                    {startTime}
                </div>
              </div>

              {/* タイトル・場所・ステータス */}
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'4px'}}>
                    <div style={{ fontWeight: 'bold', fontSize: '15px', color: '#333', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', marginRight:'5px' }}>
                        {event.title}
                    </div>
                </div>
                
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                    <div style={{ fontSize: '11px', color: '#999' }}>
                        📍 {event.venue}
                    </div>
                    
                    {/* ステータスバッジ */}
                    <span className="badge" style={{ 
                        background: statusBg, 
                        color: statusColor,
                        border: `1px solid ${borderColor}`,
                        whiteSpace: 'nowrap',
                        marginLeft: '5px'
                    }}>
                        {fullText}
                    </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UpcomingEvents;